import { AppData } from '@/types/app';
import { createContext, useContext } from 'react';

export const AppDataContext = createContext<AppData>({} as AppData);

export const useAppData = () => useContext(AppDataContext);
